import { FC } from 'react';
import { Stack, Text } from '@chakra-ui/react';
import { ChartLineDownIcon } from '@phosphor-icons/react';

export const ChartEmptyState: FC = () => (
  <Stack align="center" justify="center" gap={2} py={6} px={4} textAlign="center">
    <ChartLineDownIcon size={24} color="var(--c-text-3)" weight="regular" />
    <Text fontSize="13px" style={{ color: 'var(--c-text-3)' }}>
      Nessun dato disponibile
    </Text>
  </Stack>
);
